import React, { useState, useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

//import AuthService from '../../../business-api/AuthService'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem2,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import {
    IconButtonModoApresentacao,
    IconButtonModoApresentacaoSetas,
    IconButtonEstudoRevisaoDados,
    IconButtonEstudoParametros,
    IconButtonSelecionarCenariosTipoMorteInvalidez,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
    pesquisaIndexList,
} from '../../../business-rules/List/ListService'

import tabEstudoFormList from '../../../business-rules/List/tabEstudoFormList'

import acumulacaoList from '../../../business-rules/List/acumulacaoList'

import protecaoList from '../../../business-rules/List/protecaoList'

import {
    informouObjetivos,
} from '../cadastro-form/CadastroServiceObjetivos'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    inicializaEstudo,
    processaCalculoEstudo
} from './EstudoServiceCalculo'

import {
    informouConsideracoesFinais,
} from '../consideracoesFinais-form/ConsideracoesFinaisService'

import {
    calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria,
} from '../estudo-chart/HipotesesRetornoRealProjetoVidaSonhoTracarMetaChartService'

import {
    EstudoFormCenarios,
} from '../estudo-parametros/EstudoFormCenarios'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    calculaJsonPaginaPaginaAdicional,
    calcularPaginas,
} from '../estudo-report/EstudoReportService'

import {
    modoApresentacao,
    exibirRelatorioModoApresentacao,
} from './EstudoService'

import {
    calculaJaAposentou,
} from './EstudoServiceCalculo'

import {
    CustomizedDialogsPopupCotacao
} from './EstudoComp'

import EstudoFormAlertaCamposObrigatorios from './EstudoFormAlertaCamposObrigatorios'

import EstudoFormRevisaoDados from './EstudoFormRevisaoDados'

import EstudoFormParametros from '../estudo-parametros/EstudoFormParametros'

import EstudoFormObjetivos from './EstudoFormObjetivos'

//import EstudoFormPerguntas from './EstudoFormPerguntas'

import AnalisePatrimonialChart from '../estudo-chart/AnalisePatrimonialChart'

import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'

import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'

import ConsumoReservaAposentadoriaChart from '../estudo-chart/ConsumoReservaAposentadoriaChart'

import DiagnosticoAposentadoriaChart from '../estudo-chart/DiagnosticoAposentadoriaChart'

import DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart'

//import RecursosFinanceirosAcumuladosChart from '../estudo-chart/RecursosFinanceirosAcumuladosChart'

//import LiquidezFinanceiraAcumuladaChart from '../estudo-chart/LiquidezFinanceiraAcumuladaChart'

import HipotesesRetornoRealChart from '../estudo-chart/HipotesesRetornoRealChart'

import EstudoFormProjetoVidaSonhoTracarMeta from './EstudoFormProjetoVidaSonhoTracarMeta'

import ProjetoVidaSonhoTracarMetaChart from '../estudo-chart/ProjetoVidaSonhoTracarMetaChart'

//import EstudoFormMorteInvalidez from './EstudoFormMorteInvalidez.jsx'

import EstudoFormProtecaoSugeridaClienteConjuge from './EstudoFormProtecaoSugeridaClienteConjuge'

import DespesasAcumuladasChart from '../estudo-chart/DespesasAcumuladasChart'

import EstudoFormSucessaoVitalicia from './EstudoFormSucessaoVitalicia'

import EstudoFormDespesasPanelRadioGroup from '../estudo-panel/EstudoFormDespesasPanelRadioGroup'

import EstudoFormGarantiasPanelRadioGroup from '../estudo-panel/EstudoFormGarantiasPanelRadioGroup'

import EstudoReportResumoNecessidadeProtecao from '../estudo-report/EstudoReportResumoNecessidadeProtecao'

//import SeguroVidaFamiliaresChart from '../estudo-chart/SeguroVidaFamiliaresChart'

import PrevidenciaPrivadaForm from '../previdencia-privada/PrevidenciaPrivadaForm'

import EstudoFormConsideracoesFinais from './EstudoFormConsideracoesFinais'

import EstudoReport from '../estudo-report/EstudoReport'

import EstudoReportFormatoReport from '../estudo-report/EstudoReportFormatoReport'

import EstudoFormComparacaoFinanciamentos from './EstudoFormComparacaoFinanciamentos'

import ConsorcioFormSimulacao from '../consorcio-form/ConsorcioFormSimulacao'

import ComparacaoCenariosEstudosChart from '../estudo-chart/ComparacaoCenariosEstudosChart'

import EstudoFormComparacaoCenariosEstudos from './EstudoFormComparacaoCenariosEstudos'

import GestaoPatrimonialFormSucessao from '../gestaoPatrimonial-form/GestaoPatrimonialFormSucessao'

import GestaoPatrimonialFormVisao from '../gestaoPatrimonial-form/GestaoPatrimonialFormVisao'

import GestaoPatrimonialFormEstruturaFamiliar from '../gestaoPatrimonial-form/GestaoPatrimonialFormEstruturaFamiliar'

import GestaoPatrimonialFormFluxoCaixa from '../gestaoPatrimonial-form/GestaoPatrimonialFormFluxoCaixa'

import GestaoPatrimonialFormResumoPatrimonial from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonial'

import CarteiraInvestimentosChart from '../estudo-chart/CarteiraInvestimentosChart'

import ProjecaoSucessaoVitaliciaChart from '../estudo-chart/ProjecaoSucessaoVitaliciaChart'

import EstudoFormResumoSeguroVidaCotacao from './EstudoFormResumoSeguroVidaCotacao'

import EstudoFormTabelaEvolucaoValorResgate from './EstudoFormTabelaEvolucaoValorResgate'

import EstudoFormTabelaEvolucaoCS from './EstudoFormTabelaEvolucaoCS'

import EstudoFormTabelaEvolucaoCancelamentoApolice from './EstudoFormTabelaEvolucaoCancelamentoApolice'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

import AnaliseInvestimentoVersusSeguroVidaInteiraChart from '../estudo-chart/AnaliseInvestimentoVersusSeguroVidaInteiraChart'

import AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart from '../estudo-chart/AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart'

import EstudoFormPatrimonialProjecaoFutura from './EstudoFormPatrimonialProjecaoFutura'

import GestaoPatrimonialFormEstrategiasPlanejamento from '../gestaoPatrimonial-form/GestaoPatrimonialFormEstrategiasPlanejamento'



const EstudoForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    vars, linhaFormList, tabClienteFormList, arquivoList, obterArquivoList }) => {

    const estudo = useRef(null)

    const [expandiu, setExpandiu] = useState(false)
    const [naoCalcular, setNaoCalcular] = useState(false)


    
    const tabEstudoFormListAux = tabEstudoFormList(linhaFormList, values, vars.linhaTipoLicenca, tabClienteFormList)
    
    const [tabIndexEstudo, setTabIndexEstudo] =
        useState(
            tabEstudoFormListAux.length - 1 < values.tabIndexEstudo
                ?
                    0
                :
                    //descricaoMenu(tabEstudoFormListAux[values.tabIndexEstudo]) === LABEL.relatorio
                    //    ?
                    //        0 //values.tabIndexEstudo - 1
                    //    :
                            values.tabIndexEstudo
        )

    if (tabEstudoFormListAux.length - 1 < values.tabIndexEstudo) {

        setTabIndexEstudo(0)
    }

    const handleTabChangeEstudo = (e, value) => {

        setTabIndexEstudo(value)

        values.formatoReport = HARDCODE.idFormatoReportApresentacao // replicado em useSingleton
        
        setFieldValue('tabEstudoFormList', descricaoMenu(tabEstudoFormListAux[value])) // ver useSingleton // foi incluído aqui para forçar a atualização do ClienteFormCliente - CustomizedDialogsVideo - idFuncionalidade()
    }



    const labelIconButtonSelecionarCenariosTipoMorteInvalidez = () => {

        let label

        if (
                values.cenarios.length > 1 &&
                (
                    descricaoMenu(tabEstudoFormListAux[tabIndexEstudo]) === LABEL.protecao ||
                    descricaoMenu(tabEstudoFormListAux[tabIndexEstudo]) === LABEL.relatorio
                )
        ) {

            label = LABEL.selecionarCenariosTipoMorteInvalidez.replace('$1$', values.descricaoCenario)

        } else {

            if (values.cenarios.length > 1) {

                label = LABEL.selecionarCenariosComDescricao.replace('$1$', values.descricaoCenario)

            } else {

                label = LABEL.selecionarTipoMorteInvalidez
            }
        }
        
        return label
    }



    const tabIndexEstudoTratada = tabEstudoFormListAux.length - 1 < tabIndexEstudo ? 0 : tabIndexEstudo

    const report = descricaoMenu(tabEstudoFormListAux[tabIndexEstudoTratada]) === LABEL.relatorio ? true : false



    useSingleton(() => {

        estudo.current = inicializaEstudo(/*vars.jsonConfiguracao*/)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)
        
        values.tabIndexEstudoAnt = null

        values.tabEstudoFormList = descricaoMenu(tabEstudoFormListAux[tabIndexEstudoTratada]) // ver handleTabChangeEstudo

        values.formatoReport = HARDCODE.idFormatoReportApresentacao // replicado em handleTabChangeEstudo
    })



    if (!expandiu && !naoCalcular) {

        values.tabIndexEstudo = tabIndexEstudo

        if (
                values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras ||
                values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura
        ) {

            processaCalculoEstudo(values, handleSubmitAutomatico, estudo, false, true/*false*/,
                HARDCODE.origemCalculoEstudoPrimeiraReuniaoPlanilha, true, vars.jsonConfiguracao, false)

        } else {

            values.tabClienteFormList = tabClienteFormList

            processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, false,
                report ? HARDCODE.origemCalculoEstudoEstudoReport : HARDCODE.origemCalculoEstudoEstudo,
                    values.tabEstudoFormList !== LABEL.previdenciaPrivada &&
                    values.tabEstudoFormList !== LABEL.consorcio &&
                    values.tabEstudoFormList !== LABEL.comparacaoFinanciamentos ? true : false, vars.jsonConfiguracao,
                        values.tabEstudoFormList === LABEL.comparacaoFinanciamentos || report ? true : false)
            
            values.tabClienteFormList = tabClienteFormList
        }

        values.tabIndexEstudoAnt = values.tabIndexEstudo
        values.cenarioAtualAnt = values.cenarioAtual
    }
    
    const modoApresentacaoRelatorio = (pagina) => {

        setFieldValue(
            'modoApresentacaoRelatorio',
            pagina
        )
    }

    if (!values.modoApresentacaoRelatorio || !pesquisaList(values.reportImprimir, values.modoApresentacaoRelatorio).id) {

        modoApresentacaoRelatorio(values.reportImprimir[0].id)
    }

    const modoApresentacaoAcumulacao = (grafico) => {

        setFieldValue(
            'modoApresentacaoAcumulacao',
            grafico
        )
    }

    if (!values.modoApresentacaoAcumulacao) {

        modoApresentacaoAcumulacao(acumulacaoList(vars.linhaTipoLicenca)[0].id)
    }
    
    const modoApresentacaoProtecao = (grafico) => {

        setFieldValue(
            'modoApresentacaoProtecao',
            grafico
        )
    }

    if (!values.modoApresentacaoProtecao) {

        modoApresentacaoProtecao(protecaoList[0].id)
    }

    const exibirPagina = (id) => {

        let exibir = true

        if (
                (
                    id === HARDCODE.estudoFormObjetivos &&
                    !informouObjetivos(values)
                ) ||
                (
                    id === HARDCODE.estudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo &&
                    !values.planejamentoEspecializacaoPeriodoSabatico
                ) ||
                (
                    id === HARDCODE.gestaoPatrimonialFormEstruturaFamiliar &&
                    !values.percMeacaoCliente
                ) ||
                (
                    id === HARDCODE.estudoFormTabelaEvolucaoValorResgate &&
                    !existeTabelaEvolucaoValorResgate(values)
                ) ||
                (
                    id === HARDCODE.estudoFormTabelaEvolucaoValorResgateComparacaoPreco &&
                    !existeTabelaEvolucaoValorResgate(values)
                ) ||
                (
                    id === HARDCODE.estudoFormProjetoVidaSonhoTracarMeta &&
                    (
                        !estudo.current.projetoVidaSonhoTracarMeta || 
                        estudo.current.projetoVidaSonhoTracarMeta.length === 0
                    )
                ) ||
                (
                    id === HARDCODE.previdenciaPrivadaFormPrevidenciaPrivada &&
                    (
                        !values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador ||
                        calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))
                    )
                ) ||
                (
                    id === HARDCODE.consorcioFormSimulacaoItemReport &&
                    (
                        !values.objConsorcio ||
                        !values.objConsorcio.simulacao ||
                        !values.objConsorcio.simulacao.length === 0
                    )
                ) ||
                /*
                (
                    id === HARDCODE.consorcioFormSimulacao &&
                    (
                        !values.objConsorcio ||
                        !values.objConsorcio.simulacao ||
                        !values.objConsorcio.simulacao.length === 0
                    )
                ) ||
                 */
                (
                    id === HARDCODE.estudoFormComparacaoFinanciamentos &&
                    (
                        !values.objComparacaoFinanciamentos.idFinanciamentoSugerido ||
                        //(
                        //    !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                        //    !values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
                        //) ||
                        !estudo.current.fluxoCaixaMensalEconomiaPerdaResumo
                    )
                ) ||
                (
                    id === HARDCODE.estudoFormComparacaoFinanciamentosDetalhe &&
                    (
                        !values.objComparacaoFinanciamentos.idFinanciamentoSugerido ||
                        //(
                        //    !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                        //    !values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
                        //) ||
                        !estudo.current.fluxoCaixaMensalEconomiaPerdaDetalhe
                    )
                ) ||
                (
                    id === HARDCODE.estudoFormDespesasDiaDiaDespesasVitalicias &&
                    estudo.current.diaDiaDespesasVitalicias.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormDespesasEducacao &&
                    estudo.current.educacao.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormDespesasFinanciamento &&
                    estudo.current.financiamento.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormDespesasDiaDiaDespesasTemporarias &&
                    estudo.current.diaDiaDespesasTemporarias.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormProjetoVidaSonho &&
                    estudo.current.projetoVidaSonho.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormGarantiasPatrimonioImobilizado &&
                    estudo.current.patrimonioImobilizado.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormGarantiasReceitaMensal &&
                    estudo.current.receitaMensal.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormGarantiasRecursosFinanceiros &&
                    estudo.current.recursosFinanceiros.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormSeguroVida &&
                    estudo.current.seguroVida.length === 0
                ) ||
                (
                    id === HARDCODE.estudoFormComparacaoEstudosGrafico &&
                    values.jsonComparacaoEstudos.estudos.length <= 1
                ) ||
                (
                    id === HARDCODE.estudoFormComparacaoEstudos &&
                    values.jsonComparacaoEstudos.estudos.length <= 1
                ) ||
                (
                    id === HARDCODE.estudoFormConsideracoesFinais &&
                    !informouConsideracoesFinais(values)
                ) ||
                (
                    id.indexOf(HARDCODE.estudoFormPagina) !== -1 &&
                    calcularPaginas(values, calculaJsonPaginaPaginaAdicional(values, vars), id).length === 0
                ) ||
                (
                    id.indexOf(HARDCODE.estudoFormDisclaimer) !== -1 &&
                    values.modoApresentacao
                )
        ) {

            exibir = false
        }

        return exibir
    }

    const exibirGrafico = (id) => {

        let exibir = true

        if (
                (
                    id === HARDCODE.estudoFormProjetoVidaSonhoTracarMeta &&
                    (
                        !estudo.current.projetoVidaSonhoTracarMeta ||
                        estudo.current.projetoVidaSonhoTracarMeta.length === 0
                    )
                )
        ) {

            exibir = false
        }

        return exibir
    }

    const modoApresentacaoAnterior = () => {

        if (exibirRelatorioModoApresentacao(values)) {

            let index = pesquisaIndexList(values.reportImprimir, values.modoApresentacaoRelatorio) - 1

            if (index === -1) {

                index = values.reportImprimir.length - 1
            }

            if (!exibirPagina(values.reportImprimir[index].id)) {

                values.modoApresentacaoRelatorio = values.reportImprimir[index].id

                modoApresentacaoAnterior()

            } else {

                modoApresentacaoRelatorio(values.reportImprimir[index].id)
            }

        } else {

            if (values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados) {

                let index = pesquisaIndexList(acumulacaoList(vars.linhaTipoLicenca), values.modoApresentacaoAcumulacao) - 1
    
                if (index === -1) {
    
                    index = acumulacaoList(vars.linhaTipoLicenca).length - 1
                }
    
                if (!exibirGrafico(acumulacaoList(vars.linhaTipoLicenca)[index].id)) {
    
                    values.modoApresentacaoAcumulacao = acumulacaoList(vars.linhaTipoLicenca)[index].id
    
                    modoApresentacaoAnterior()
    
                } else {
    
                    modoApresentacaoAcumulacao(acumulacaoList(vars.linhaTipoLicenca)[index].id)
                }

            } else {

                if (values.tabEstudoFormList === LABEL.protecao) {

                    let index = pesquisaIndexList(protecaoList, values.modoApresentacaoProtecao) - 1
        
                    if (index === -1) {
        
                        index = protecaoList.length - 1
                    }
        
                    if (!exibirGrafico(protecaoList[index].id)) {
        
                        values.modoApresentacaoProtecao = protecaoList[index].id
        
                        modoApresentacaoAnterior()
        
                    } else {
        
                        modoApresentacaoProtecao(protecaoList[index].id)
                    }
                }
            }
        }
    }

    const modoApresentacaoProxima = () => {
        
        if (exibirRelatorioModoApresentacao(values)) {

            let index = pesquisaIndexList(values.reportImprimir, values.modoApresentacaoRelatorio) + 1

            if (index === values.reportImprimir.length) {

                index = 0
            }

            if (!exibirPagina(values.reportImprimir[index].id)) {

                values.modoApresentacaoRelatorio = values.reportImprimir[index].id

                modoApresentacaoProxima()

            } else {

                modoApresentacaoRelatorio(values.reportImprimir[index].id)
            }

        } else {

            if (values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados) {

                let index = pesquisaIndexList(acumulacaoList(vars.linhaTipoLicenca), values.modoApresentacaoAcumulacao) + 1
    
                if (index === acumulacaoList(vars.linhaTipoLicenca).length) {
    
                    index = 0
                }
    
                if (!exibirGrafico(acumulacaoList(vars.linhaTipoLicenca)[index].id)) {
    
                    values.modoApresentacaoAcumulacao = acumulacaoList(vars.linhaTipoLicenca)[index].id
    
                    modoApresentacaoProxima()
    
                } else {
    
                    modoApresentacaoAcumulacao(acumulacaoList(vars.linhaTipoLicenca)[index].id)
                }

            } else {

                if (values.tabEstudoFormList === LABEL.protecao) {

                    let index = pesquisaIndexList(protecaoList, values.modoApresentacaoProtecao) + 1
        
                    if (index === protecaoList.length) {
        
                        index = 0
                    }
        
                    if (!exibirGrafico(protecaoList[index].id)) {
        
                        values.modoApresentacaoProtecao = protecaoList[index].id
        
                        modoApresentacaoProxima()
        
                    } else {
        
                        modoApresentacaoProtecao(protecaoList[index].id)
                    }
                }
            }
        }
    }



    const Acumulacao = () => {

        return (
            naoCalcular ||
            (
                !values.modoApresentacao &&
                values.tabEstudoFormList !== LABEL.acumulacao &&
                values.tabEstudoFormList !== LABEL.conferenciaDados
            )
                ?
                    ''
                :
                    <>
                        {(!values.modoApresentacao || values.modoApresentacaoAcumulacao ===
                        HARDCODE.analisePatrimonialChart) && (
                            <AnalisePatrimonialChart
                                values={values}
                                setFieldValue={setFieldValue}
                                estudo={estudo}
                                moreLessList={HARDCODE.moreLessAcumulacao}
                            />
                        )}

                        {(!values.modoApresentacao || values.modoApresentacaoAcumulacao === HARDCODE.receitaAnualChart) && (
                            <ReceitaAnualChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                setFieldValue={setFieldValue}
                                estudo={estudo}
                                vars={vars}
                                moreLessList={HARDCODE.moreLessAcumulacao}
                            />
                        )}

                        {(!values.modoApresentacao || values.modoApresentacaoAcumulacao === HARDCODE.despesaAnualChart) && (
                            <DespesaAnualChart
                                values={values}
                                setFieldValue={setFieldValue}
                                estudo={estudo}
                                vars={vars}
                                moreLessList={HARDCODE.moreLessAcumulacao}
                            />
                        )}

                        {(!values.modoApresentacao || values.modoApresentacaoAcumulacao ===
                        HARDCODE.balancoReceitaXDespesaAnualChart) && (
                            <BalancoReceitaXDespesaAnualChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                setFieldValue={setFieldValue}
                                estudo={estudo}
                                vars={vars}
                                moreLessList={HARDCODE.moreLessAcumulacao}
                            />
                        )}

                        {vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                            <>
                                {(!values.modoApresentacao || values.modoApresentacaoAcumulacao ===
                                HARDCODE.consumoReservaAposentadoriaChart) && (
                                    <ConsumoReservaAposentadoriaChart
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        estudo={estudo}
                                        vars={vars}
                                        moreLessList={HARDCODE.moreLessAcumulacao}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoAcumulacao ===
                                HARDCODE.diagnosticoAposentadoriaChart) && (
                                    <DiagnosticoAposentadoriaChart
                                        values={values}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                        estudo={estudo}
                                        moreLessList={HARDCODE.moreLessAcumulacao}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoAcumulacao ===
                                HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart) && (
                                    <>
                                        <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            estudo={estudo}
                                            moreLessList={HARDCODE.moreLessAcumulacao}
                                        />

                                        {!values.naoExibirHipotesesRetornoRealAposentadoria &&
                                        calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria(
                                        values) !== 0 && (values.modoApresentacao || values.moreLessAcumulacao[pesquisaIndexList(
                                        values.moreLessAcumulacao,
                                        HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart)].expanded) && (
                                            <HipotesesRetornoRealChart
                                                values={values}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                estudo={estudo}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                            />
                                        )}
                                    </>
                                )}

                                {/*
                                <RecursosFinanceirosAcumuladosChart
                                    estudo={estudo}
                                />
                                */}
                                {/*
                                <LiquidezFinanceiraAcumuladaChart
                                    estudo={estudo}
                                />
                                */}

                                {(!values.modoApresentacao ||
                                values.modoApresentacaoAcumulacao === HARDCODE.estudoFormProjetoVidaSonhoTracarMeta) &&
                                exibirGrafico(HARDCODE.estudoFormProjetoVidaSonhoTracarMeta) && (
                                    <>
                                        <EstudoFormProjetoVidaSonhoTracarMeta
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            moreLessList={HARDCODE.moreLessAcumulacao}
                                        />

                                        {values.exibirHipotesesRetornoRealProjetoVidaSonho && 
                                        (values.modoApresentacao || values.moreLessAcumulacao[pesquisaIndexList(
                                            values.moreLessAcumulacao, HARDCODE.estudoFormProjetoVidaSonhoTracarMeta)].expanded) && (
                                            <ProjetoVidaSonhoTracarMetaChart
                                                values={values}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                estudo={estudo}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                            />
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </>
        )
    }


    const Protecao = () => {

        return (
            naoCalcular || (!values.modoApresentacao && values.tabEstudoFormList !== LABEL.protecao)
                ?
                    ''
                :
                    values.tabEstudoFormList === LABEL.protecao && !expandiu
                        ?
                            <>
                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'EstudoFormProtecaoSugeridaClienteConjuge') && (
                                    <EstudoFormProtecaoSugeridaClienteConjuge
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        vars={vars}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao ===
                                HARDCODE.analisePatrimonialChart) && (
                                    <AnalisePatrimonialChart
                                        values={values}
                                        estudo={estudo}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'EstudoFormSucessaoVitalicia') && (
                                    <EstudoFormSucessaoVitalicia
                                        values={values}
                                        estudo={estudo}
                                        //jsonConfiguracao={vars.jsonConfiguracao}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'ProjecaoSucessaoVitaliciaChart') && (
                                    <ProjecaoSucessaoVitaliciaChart
                                        values={values}
                                        estudo={estudo}
                                        report={false}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'DespesasAcumuladasChart') && (
                                    <DespesasAcumuladasChart 
                                        values={values}
                                        handleChange={handleChange}
                                        estudo={estudo}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'EstudoFormDespesasPanelRadioGroup') && (
                                    <EstudoFormDespesasPanelRadioGroup
                                        values={values}
                                        estudo={estudo}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'EstudoFormGarantiasPanelRadioGroup') && (
                                    <EstudoFormGarantiasPanelRadioGroup
                                        values={values}
                                        estudo={estudo}
                                    />
                                )}

                                {(!values.modoApresentacao || values.modoApresentacaoProtecao === 'EstudoReportResumoNecessidadeProtecao') && (
                                    <EstudoReportResumoNecessidadeProtecao
                                        values={values}
                                        estudo={estudo}
                                    />
                                )}

                                {/*tabIndexEstudo ajustar === 1 && (
                                    <SeguroVidaFamiliaresChart 
                                        values={values}
                                        estudo={estudo}
                                    />
                                )*/}
                            </>
                        :
                            ''
        )
    }



    const Relatorio = () => {

        return (
            naoCalcular || (!values.modoApresentacao && values.tabEstudoFormList !== LABEL.relatorio)
                ?
                    ''
                :
                    <EstudoReport
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        setFieldValue={setFieldValue}
                        estudo={estudo}
                        vars={vars}
                        linhaFormList={linhaFormList}
                        modoApresentacaoRelatorio={modoApresentacaoRelatorio}
                        exibirPagina={exibirPagina}
                    />
        )
    }


    const Cenario = () => {
    
        return (
            values.cenarios.length > 1
                ?
                    <GridContainer
                        align='center'
                        //className='mt--5 mb-5'
                        //className={'mt--7 ' + (values.tabEstudoFormList === LABEL.relatorio ? 'mb-3' : 'mb-1')}
                        className='mt--1 mb--4'
                    >
                        <GridItem2>

                        </GridItem2>
                        <GridItem10>
                            {/*
                            <h4>
                                {values.descricaoCenario}
                            </h4>
                            */}
                            <EstudoFormCenarios
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                toogle={true}
                            />

                            {/*(
                                (
                                    values.tabEstudoFormList === LABEL.protecao ||
                                    values.tabEstudoFormList === LABEL.relatorio
                                ) && !values.jsonAcessoCliente.acessoCliente && !expandiu &&
                                tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada
                            ) && (
                                <EstudoFormMorteInvalidez
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    toogle={true}
                                />
                            )*/}
                        </GridItem10>
                    </GridContainer>
                :
                    ''
        )
    }


    
    return (
        tabEstudoFormListAux.length - 1 >= values.tabIndexEstudo
            ?
                <DivForm>
                    {tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada && (
                        <EstudoFormAlertaCamposObrigatorios
                            values={values}
                            handleSubmit={handleSubmit}
                        />
                    )}
                    
                    {tabEstudoFormListAux.length > 1 && (
                        <TabsPadrao
                            value={tabIndexEstudo}
                            onChange={handleTabChangeEstudo}
                            level={2}
                        >
                            {tabEstudoFormListAux?.map((item, ind) => (
                                <TabPadrao
                                    value={ind}
                                    label={item}
                                    key={ind}
                                    level={3}
                                />
                            ))}
                        </TabsPadrao>
                    )}

                    {(
                        values.tabEstudoFormList === LABEL.resumo ||
                        values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados ||
                        values.tabEstudoFormList === LABEL.protecao ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonial ||
                        values.tabEstudoFormList === LABEL.comparacaoFinanciamentos ||
                        values.tabEstudoFormList === LABEL.relatorio ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonialSucessao ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura
                    ) && (
                        <EstudoFormCenarios
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                        />
                    )}
                    
                    {/*(
                        (
                            values.tabEstudoFormList === LABEL.protecao ||
                            values.tabEstudoFormList === LABEL.relatorio
                        ) && !values.jsonAcessoCliente.acessoCliente && !expandiu &&
                        tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada
                    ) && (
                        <EstudoFormMorteInvalidez
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                        />
                    )*/}

                    {(
                        (values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados) &&
                        !expandiu
                    ) && (
                        <CustomizedDialogsPopup
                            maxWidth="xl"
                            fullScreen={true}
                            //popupTitle={''/*LABEL.acumulacao LABEL.conferenciaDados*/}
                            popupTitleComponent={
                                <Cenario/>
                            }
                            tooltipTitle={LABEL.modoApresentacao}
                            PopupButton={IconButtonModoApresentacao}
                            popupComponent={
                                <Acumulacao/>
                            }
                            popupNavegacao={
                                <>  
                                    <IconButtonModoApresentacaoSetas
                                        values={values}
                                        modoApresentacaoAnterior={modoApresentacaoAnterior}
                                        modoApresentacaoProxima={modoApresentacaoProxima}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormRevisaoDados*/
                                        maxWidth="xl"
                                        popupTitle={LABEL.revisaoDados}
                                        tooltipTitle={LABEL.revisaoDados}
                                        PopupButton={IconButtonEstudoRevisaoDados}
                                        bgDefault={true}
                                        popupComponent={
                                            <EstudoFormRevisaoDados
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                                setFieldValue={setFieldValue}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                vars={vars}
                                                //linhaTipoLicenca={vars.linhaTipoLicenca}
                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                                //jsonUsuario={vars.jsonUsuario}
                                                //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                somenteDespesas={false}
                                                popup={true}
                                            />
                                        }
                                        open={setNaoCalcular}
                                        onClose={() => {estudo.current.calculou = false}}
                                        afterClose={setNaoCalcular}
                                        salvarFechar={true}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormParametros*/
                                        maxWidth="xl"
                                        popupTitle={LABEL.parametros}
                                        tooltipTitle={LABEL.parametros}
                                        PopupButton={IconButtonEstudoParametros}
                                        bgDefault={true}
                                        popupComponent={
                                            <div
                                                className='ml-4 mr-4'
                                            >
                                                <EstudoFormParametros
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    handleSubmit={handleSubmit}
                                                    setFieldValue={setFieldValue}
                                                    vars={vars}
                                                />
                                            </div>
                                        }
                                        open={setNaoCalcular}
                                        afterClose={setNaoCalcular}
                                        salvarFechar={true}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormCenarios-EstudoFormMorteInvalidez*/
                                        maxWidth="xl"
                                        popupTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        tooltipTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        PopupButton={IconButtonSelecionarCenariosTipoMorteInvalidez}
                                        bgDefault={true/*values.tabEstudoFormList !== LABEL.protecao*/}
                                        popupComponent={
                                            <>
                                                {values.cenarios.length > 1 && (
                                                    <EstudoFormCenarios
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        toogle={false}
                                                    />
                                                )}

                                                {/*(
                                                    values.tabEstudoFormList === LABEL.protecao ||
                                                    values.tabEstudoFormList === LABEL.relatorio
                                                ) && (
                                                    <EstudoFormMorteInvalidez
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        toogle={false}
                                                    />
                                                )*/}

                                                {values.tabEstudoFormList !== LABEL.protecao &&
                                                vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" && (
                                                    <>
                                                        <ComparacaoCenariosEstudosChart
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                            selecaoCenarios={true}
                                                        />

                                                        <EstudoFormComparacaoCenariosEstudos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        }
                                    />
                                </>
                            }
                            open={() => modoApresentacao(setFieldValue, true)}
                            afterClose={() => modoApresentacao(setFieldValue, false)}
                        />
                    )}

                    {(
                        values.tabEstudoFormList === LABEL.protecao && !expandiu
                    ) && (
                        <CustomizedDialogsPopup
                            maxWidth="xl"
                            fullScreen={true}
                            //popupTitle={''/*LABEL.protecao*/}
                            popupTitleComponent={
                                <Cenario/>
                            }
                            tooltipTitle={LABEL.modoApresentacao}
                            PopupButton={IconButtonModoApresentacao}
                            popupComponent={
                                <Protecao/>
                            }
                            popupNavegacao={
                                <>
                                    <IconButtonModoApresentacaoSetas
                                        values={values}
                                        modoApresentacaoAnterior={modoApresentacaoAnterior}
                                        modoApresentacaoProxima={modoApresentacaoProxima}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormRevisaoDados*/
                                        maxWidth="xl"
                                        popupTitle={LABEL.revisaoDados}
                                        tooltipTitle={LABEL.revisaoDados}
                                        PopupButton={IconButtonEstudoRevisaoDados}
                                        bgDefault={true}
                                        popupComponent={
                                            <EstudoFormRevisaoDados
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                                setFieldValue={setFieldValue}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                vars={vars}
                                                //linhaTipoLicenca={vars.linhaTipoLicenca}
                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                                //jsonUsuario={vars.jsonUsuario}
                                                //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                somenteDespesas={false}
                                                popup={true}
                                            />
                                        }
                                        open={setNaoCalcular}
                                        onClose={() => {estudo.current.calculou = false}}
                                        afterClose={setNaoCalcular}
                                        salvarFechar={true}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormParametros*/
                                        maxWidth="xl"
                                        popupTitle={LABEL.parametros}
                                        tooltipTitle={LABEL.parametros}
                                        PopupButton={IconButtonEstudoParametros}
                                        bgDefault={true}
                                        popupComponent={
                                            <div
                                                className='ml-4 mr-4'
                                            >
                                                <EstudoFormParametros
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    handleSubmit={handleSubmit}
                                                    setFieldValue={setFieldValue}
                                                    vars={vars}
                                                />
                                            </div>
                                        }
                                        open={setNaoCalcular}
                                        afterClose={setNaoCalcular}
                                        salvarFechar={true}
                                    />

                                    <CustomizedDialogsPopup /*replicado EstudoFormCenarios-EstudoFormMorteInvalidez*/
                                        maxWidth="xl"
                                        popupTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        tooltipTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        PopupButton={IconButtonSelecionarCenariosTipoMorteInvalidez}
                                        bgDefault={true/*values.tabEstudoFormList !== LABEL.protecao*/}
                                        popupComponent={
                                            <>
                                                {values.cenarios.length > 1 && (
                                                    <EstudoFormCenarios
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        toogle={false}
                                                    />
                                                )}

                                                {/*(
                                                    values.tabEstudoFormList === LABEL.protecao ||
                                                    values.tabEstudoFormList === LABEL.relatorio
                                                ) && (
                                                    <EstudoFormMorteInvalidez
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        toogle={false}
                                                    />
                                                )*/}

                                                {values.tabEstudoFormList !== LABEL.protecao &&
                                                vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" && (
                                                    <>
                                                        <ComparacaoCenariosEstudosChart
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                            selecaoCenarios={true}
                                                        />

                                                        <EstudoFormComparacaoCenariosEstudos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        }
                                    />
                                </>
                            }
                            open={() => modoApresentacao(setFieldValue, true)}
                            afterClose={() => modoApresentacao(setFieldValue, false)}
                        />
                    )}

                    {(
                        exibirRelatorioModoApresentacao(values) && !expandiu
                    ) && (
                        <CustomizedDialogsPopup
                            maxWidth="xl"
                            fullScreen={true}
                            //popupTitle={''/*LABEL.relatorio*/}
                            popupTitleComponent={
                                <Cenario/>
                            }
                            tooltipTitle={LABEL.modoApresentacao}
                            PopupButton={IconButtonModoApresentacao}
                            popupComponent={
                                <Relatorio/>
                            }
                            popupNavegacao={
                                <>
                                    <IconButtonModoApresentacaoSetas
                                        values={values}
                                        modoApresentacaoAnterior={modoApresentacaoAnterior}
                                        modoApresentacaoProxima={modoApresentacaoProxima}
                                    />

                                    {!values.jsonAcessoCliente.acessoCliente && (

                                        <CustomizedDialogsPopup /*replicado EstudoFormRevisaoDados*/
                                            maxWidth="xl"
                                            popupTitle={LABEL.revisaoDados}
                                            tooltipTitle={LABEL.revisaoDados}
                                            PopupButton={IconButtonEstudoRevisaoDados}
                                            bgDefault={true}
                                            popupComponent={
                                                <EstudoFormRevisaoDados
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    handleSubmit={handleSubmit}
                                                    setFieldValue={setFieldValue}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    vars={vars}
                                                    //linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    //jsonConfiguracao={vars.jsonConfiguracao}
                                                    //jsonUsuario={vars.jsonUsuario}
                                                    //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    somenteDespesas={false}
                                                    popup={true}
                                                />
                                            }
                                            open={setNaoCalcular}
                                            onClose={() => {estudo.current.calculou = false}}
                                            afterClose={setNaoCalcular}
                                            salvarFechar={true}
                                        />
                                    )}

                                    {!values.jsonAcessoCliente.acessoCliente && (
                                    
                                        <CustomizedDialogsPopup /*replicado EstudoFormParametros*/
                                            maxWidth="xl"
                                            popupTitle={LABEL.parametros}
                                            tooltipTitle={LABEL.parametros}
                                            PopupButton={IconButtonEstudoParametros}
                                            bgDefault={true}
                                            popupComponent={
                                                <div
                                                    className='ml-4 mr-4'
                                                >
                                                    <EstudoFormParametros
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        vars={vars}
                                                    />
                                                </div>
                                            }
                                            open={setNaoCalcular}
                                            afterClose={setNaoCalcular}
                                            salvarFechar={true}
                                        />
                                    )}

                                    <CustomizedDialogsPopup /*replicado EstudoFormCenarios-EstudoFormMorteInvalidez*/
                                        maxWidth="xl"
                                        popupTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        tooltipTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                                        PopupButton={IconButtonSelecionarCenariosTipoMorteInvalidez}
                                        bgDefault={true/*values.tabEstudoFormList !== LABEL.protecao*/}
                                        popupComponent={
                                            <>
                                                {values.cenarios.length > 1 && (
                                                    <EstudoFormCenarios
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        toogle={false}
                                                    />
                                                )}

                                                {/*(
                                                    values.tabEstudoFormList === LABEL.protecao ||
                                                    exibirRelatorioModoApresentacao(values)
                                                ) && (
                                                    <EstudoFormMorteInvalidez
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        toogle={false}
                                                    />
                                                )*/}

                                                {values.tabEstudoFormList !== LABEL.protecao &&
                                                vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" && (
                                                    <>
                                                        <ComparacaoCenariosEstudosChart
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                            selecaoCenarios={true}
                                                        />

                                                        <EstudoFormComparacaoCenariosEstudos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        }
                                    />
                                </>
                            }
                            open={() => modoApresentacao(setFieldValue, true)}
                            afterClose={() => modoApresentacao(setFieldValue, false)}
                        />
                    )}

                    {(
                        (
                            values.tabEstudoFormList === LABEL.resumo ||
                            values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados ||
                            values.tabEstudoFormList === LABEL.protecao ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonial ||
                            values.tabEstudoFormList === LABEL.previdenciaPrivada ||
                            values.tabEstudoFormList === LABEL.relatorio ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialFluxoCaixa ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialResumoPatrimonial ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialSucessao ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura ||
                            values.tabEstudoFormList === LABEL.comparacaoFinanciamentos ||
                            values.tabEstudoFormList === LABEL.comparacaoCenarios ||
                            values.tabEstudoFormList === LABEL.comparacaoEstudos
                        ) &&
                        !values.jsonAcessoCliente.acessoCliente &&
                        tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada
                    ) && (
                        <CustomizedDialogsPopup /*replicado EstudoFormRevisaoDados*/
                            maxWidth="xl"
                            popupTitle={LABEL.revisaoDados}
                            tooltipTitle={LABEL.revisaoDados}
                            PopupButton={IconButtonEstudoRevisaoDados}
                            bgDefault={true}
                            popupComponent={
                                <EstudoFormRevisaoDados
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    vars={vars}
                                    //linhaTipoLicenca={vars.linhaTipoLicenca}
                                    //jsonConfiguracao={vars.jsonConfiguracao}
                                    //jsonUsuario={vars.jsonUsuario}
                                    //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    somenteDespesas={false}
                                    popup={true}
                                />
                            }
                            open={setExpandiu}
                            onClose={() => {estudo.current.calculou = false}}
                            afterClose={setExpandiu}
                            salvarFechar={true}
                        />
                    )}

                    {(
                        (
                            values.tabEstudoFormList === LABEL.resumo ||
                            values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados ||
                            values.tabEstudoFormList === LABEL.protecao ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonial ||
                            values.tabEstudoFormList === LABEL.previdenciaPrivada ||
                            values.tabEstudoFormList === LABEL.relatorio ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialFluxoCaixa ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialResumoPatrimonial ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialSucessao ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras ||
                            values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura ||
                            values.tabEstudoFormList === LABEL.comparacaoFinanciamentos ||
                            values.tabEstudoFormList === LABEL.comparacaoCenarios ||
                            values.tabEstudoFormList === LABEL.comparacaoEstudos
                        ) &&
                        !values.jsonAcessoCliente.acessoCliente &&
                        tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada
                    ) && (
                        <CustomizedDialogsPopup /*replicado EstudoFormParametros*/
                            maxWidth="xl"
                            popupTitle={LABEL.parametros}
                            tooltipTitle={LABEL.parametros}
                            PopupButton={IconButtonEstudoParametros}
                            bgDefault={true}
                            popupComponent={
                                <div
                                    className='ml-4 mr-4'
                                >
                                    <EstudoFormParametros
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        setFieldValue={setFieldValue}
                                        vars={vars}
                                    />
                                </div>
                            }
                            open={setExpandiu}
                            afterClose={setExpandiu}
                            salvarFechar={true}
                        />
                    )}

                    {(
                        values.tabEstudoFormList === LABEL.resumo ||
                        values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados ||
                        values.tabEstudoFormList === LABEL.protecao ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonial ||
                        values.tabEstudoFormList === LABEL.relatorio ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras ||
                        values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura ||
                        values.tabEstudoFormList === LABEL.comparacaoFinanciamentos ||
                        values.tabEstudoFormList === LABEL.comparacaoCenarios ||
                        values.tabEstudoFormList === LABEL.comparacaoEstudos
                    ) &&
                    (
                        values.cenarios.length > 1 ||
                        values.tabEstudoFormList === LABEL.protecao ||
                        values.tabEstudoFormList === LABEL.relatorio
                    ) && (
                        <CustomizedDialogsPopup /*replicado EstudoFormCenarios-EstudoFormMorteInvalidez*/
                            maxWidth="xl"
                            popupTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                            tooltipTitle={labelIconButtonSelecionarCenariosTipoMorteInvalidez()}
                            PopupButton={IconButtonSelecionarCenariosTipoMorteInvalidez}
                            bgDefault={true/*values.tabEstudoFormList !== LABEL.protecao*/}
                            popupComponent={
                                <>
                                    {values.cenarios.length > 1 && (
                                        <EstudoFormCenarios
                                            values={values}
                                            handleChange={handleChange}
                                            handleSubmit={handleSubmit}
                                            setFieldValue={setFieldValue}
                                            toogle={false}
                                        />
                                    )}

                                    {/*(
                                        values.tabEstudoFormList === LABEL.protecao ||
                                        values.tabEstudoFormList === LABEL.relatorio
                                    ) && (
                                        <EstudoFormMorteInvalidez
                                            values={values}
                                            handleChange={handleChange}
                                            handleSubmit={handleSubmit}
                                            toogle={false}
                                        />
                                    )*/}

                                    {values.tabEstudoFormList !== LABEL.protecao &&
                                    vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" && (
                                        <>
                                            <ComparacaoCenariosEstudosChart
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                estudo={estudo}
                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                jsonPagina={vars.jsonPagina}
                                                jsonUsuario={vars.jsonUsuario}
                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                simulacaoFinanceira={false}
                                                selecaoCenarios={true}
                                            />

                                            <EstudoFormComparacaoCenariosEstudos
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                estudo={estudo}
                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                jsonPagina={vars.jsonPagina}
                                                jsonUsuario={vars.jsonUsuario}
                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                simulacaoFinanceira={false}
                                            />
                                        </>
                                    )}
                                </>
                            }
                        />
                    )}

                    {/*values.tabEstudoFormList === LABEL.revisaoDados && (
                        <EstudoFormRevisaoDados /*replicado EstudoFormRevisaoDados
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            handleSubmitAutomatico={handleSubmitAutomatico}
                            vars={vars}
                            //linhaTipoLicenca={vars.linhaTipoLicenca}
                            //jsonConfiguracao={vars.jsonConfiguracao}
                            //jsonUsuario={vars.jsonUsuario}
                            //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                            somenteDespesas={false}
                            popup={false}
                        />
                    )*/}

                    {/*values.tabEstudoFormList === LABEL.parametros && (
                        <EstudoFormParametros /*replicado EstudoFormParametros
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            vars={vars}
                        />
                    )*/}

                    {/*(
                        values.tabEstudoFormList === LABEL.objetivos ||
                        values.tabEstudoFormList === LABEL.perguntas ||
                        (*/////values.tabEstudoFormList === LABEL.resumo &&
                            ////values.objetivosPrincipaisPreocupacoes &&
                                ////values.objetivosPrincipaisPreocupacoes !== HARDCODE.richTextEditorVazio
                                /*)
                    )*/ ////&& linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosObjetivos && !values.modoApresentacao && (
                    //{values.objetivosPrincipaisPreocupacoes &&
                    // values.objetivosPrincipaisPreocupacoes !== HARDCODE.richTextEditorVazio && (
                        ////<EstudoFormObjetivos
                        ////    values={values}
                        /////>
                    ////)
                    }

                    {/*(
                        values.tabEstudoFormList === LABEL.objetivos ||
                        values.tabEstudoFormList === LABEL.perguntas
                    ) && linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosPerguntas && (
                    //{values.objetivosPrincipaisPreocupacoes &&
                    // values.objetivosPrincipaisPreocupacoes !== HARDCODE.richTextEditorVazio && (
                        <EstudoFormPerguntas
                            values={values}
                            linhaFormList={linhaFormList}
                        />
                    )*/}

                    {values.tabEstudoFormList === LABEL.resumo && !expandiu && !values.modoApresentacao && (
                        <>
                            {informouObjetivos(values) && (
                                <>
                                    {values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => (
                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                        <EstudoFormObjetivos
                                            key={ind}
                                            values={values}
                                            indPagina={ind}
                                        />
                                    )))}
                                </>
                            )}
                            
                            {!values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho &&
                            vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S'
                                ?
                                    <>
                                        <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                            values={values}
                                            estudo={estudo}
                                        />

                                        <EstudoFormProjetoVidaSonhoTracarMeta
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                        />
                                    </>
                                :
                                    ''
                            }
                            
                            {!values.naoExibirProtecaoRiscos
                                ?
                                    <EstudoFormProtecaoSugeridaClienteConjuge
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        vars={vars}
                                    />
                                :
                                    ''
                            }

                            {informouConsideracoesFinais(values) && (
                                <>
                                    {values.consideracaoFinal?.map((item, ind) => (
                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                        <EstudoFormConsideracoesFinais
                                            key={ind}
                                            values={values}
                                            linhaFormList={linhaFormList}
                                            indPagina={ind}
                                        />
                                    )))}
                                </>
                            )}
                        </>
                    )}

                    {(values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados) &&
                    !expandiu && !values.modoApresentacao && (
                        <Acumulacao/>
                    )}

                    {!values.modoApresentacao && (
                        <Protecao/>
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonial /*&& !expandiu*/&& !values.modoApresentacao && (
                        <>
                            {values.percMeacaoCliente && !expandiu && (
                                <GestaoPatrimonialFormEstruturaFamiliar
                                    values={values}
                                />
                            )}

                            {!expandiu && (
                                <>
                                    {(
                                        estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].valorAcumuladoPainel !== 0 ||
                                        estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel !== 0 ||
                                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento].valorTotalParcelasTotalAtual !== 0
                                    ) && (
                                        <AnalisePatrimonialChart
                                            values={values}
                                            estudo={estudo}
                                        />
                                    )}

                                    {(
                                        //estudo.current.graficoEstrategiasFinanceirasRecursosFinanceirosAcumulados.length > 0 ||
                                        estudo.current.graficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.length > 0 ||
                                        values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos ||
                                        values.exibirCapitalSeguradoCarteiraInvestimentos/* ||
                                        values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos*/
                                    ) && (
                                        <CarteiraInvestimentosChart
                                            values={values}
                                            estudo={estudo}
                                            report={false}
                                            popup={false}
                                            simulacaoFinanceira={false}
                                        />
                                    )}

                                    {(
                                        values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado !== 0 ||
                                        values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros !== 0 ||
                                        values.inventarioCliente + values.inventarioConjuge !== 0
                                    ) && (
                                        <>
                                            <EstudoFormSucessaoVitalicia
                                                values={values}
                                                estudo={estudo}
                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                            />

                                            <ProjecaoSucessaoVitaliciaChart
                                                values={values}
                                                estudo={estudo}
                                                report={false}
                                            />
                                        </>
                                    )}
                                </>
                            )}

                            <CustomizedDialogsPopupCotacao
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                vars={vars}
                                setExpandiu={setExpandiu}
                            />

                            {!expandiu && (
                                estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                .filter(item => !item.utilizarApenasComparacaoPreco)?.map( (cotacao, indCotacao) => (
                                    <div
                                        key={indCotacao}
                                    >
                                        {values.exibirResumoSeguroVidaCotacao && (
                                            <EstudoFormResumoSeguroVidaCotacao
                                                values={values}
                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                utilizarApenasComparacaoPreco={false}
                                                report={false}
                                            />
                                        )}

                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                        .filter(item => !item.utilizarApenasComparacaoPreco &&
                                        item.seguradora === cotacao.id)?.map( (item, ind) => (
                                            <div
                                                key={ind}
                                            >
                                                <TabelaEvolucaoValorResgateChart
                                                    values={values}
                                                    estudo={estudo}
                                                    estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                    report={report}
                                                    tabelaEvolucaoValorResgate={true}
                                                />
                                                {/*!values.exibirTabelaEvolucaoCS && !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                    <EstudoFormTabelaEvolucaoValorResgate
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )*/}
                                                {/*values.exibirTabelaEvolucaoCS && (
                                                    <EstudoFormTabelaEvolucaoCS
                                                        values={values}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )*/}
                                                {/*values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                    <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                        values={values}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )*/}
                                                {/*(values.exibirTabelaEvolucaoCS ||
                                                values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                    <TabelaEvolucaoValorResgateChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                        tabelaEvolucaoValorResgate={false}
                                                    />
                                                )*/}
                                                {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira && 
                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                                {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira && 
                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            )}
                        </>
                    )}

                    {values.tabEstudoFormList === LABEL.previdenciaPrivada && !expandiu && !values.modoApresentacao && (
                        <PrevidenciaPrivadaForm
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            handleSubmitAutomatico={handleSubmitAutomatico}
                            estudo={estudo}
                            vars={vars}
                            linhaFormList={linhaFormList}
                            tabClienteFormList={tabClienteFormList}
                            arquivoList={arquivoList}
                            obterArquivoList={obterArquivoList}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.relatorio && !expandiu && !values.modoApresentacao && (
                        <>
                            {/*!AuthService.obterAcessoCliente(variaveisGlobais) && (*/}
                                <EstudoReportFormatoReport
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                />
                            {/*})*/}

                            <Relatorio/>
                        </>
                    )}

                    {values.tabEstudoFormList === LABEL.consorcio /*&& !expandiu */&& (
                        <ConsorcioFormSimulacao
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            linhaTipoLicenca={vars.linhaTipoLicenca}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.comparacaoFinanciamentos && !expandiu && (
                        <EstudoFormComparacaoFinanciamentos
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            estudo={estudo}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            linhaTipoLicenca={vars.linhaTipoLicenca}
                            setNaoCalcular={setNaoCalcular}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.comparacaoCenarios && !expandiu && (
                        <>
                            <ComparacaoCenariosEstudosChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                simulacaoFinanceira={false}
                            />

                            <EstudoFormComparacaoCenariosEstudos
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                simulacaoFinanceira={false}
                            />
                        </>
                    )}

                    {!values.modoApresentacao && values.tabEstudoFormList === LABEL.comparacaoEstudos && !expandiu && (
                        <>
                            <ComparacaoCenariosEstudosChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                simulacaoFinanceira={false}
                            />
                            
                            <EstudoFormComparacaoCenariosEstudos
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                simulacaoFinanceira={false}
                            />
                        </>
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialVisao && (
                        <GestaoPatrimonialFormVisao
                            jsonGestaoPatrimonial={vars.jsonGestaoPatrimonial}
                        />
                    )}
                    
                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialEstruturaFamiliar && (
                        <GestaoPatrimonialFormEstruturaFamiliar
                            values={values}
                        />
                    )}
                    
                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialFluxoCaixa && (
                        <GestaoPatrimonialFormFluxoCaixa
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            estudo={estudo}
                            vars={vars}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialResumoPatrimonial && (
                        <>
                            <GestaoPatrimonialFormResumoPatrimonial
                                values={values}
                                estudo={estudo}
                            />

                            <AnalisePatrimonialChart
                                values={values}
                                estudo={estudo}
                                naoExibirTabela={true}
                            />
                        </>
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialSucessao && (
                        <GestaoPatrimonialFormSucessao
                            values={values}
                            estudo={estudo}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras && (
                        <>
                            <CarteiraInvestimentosChart
                                values={values}
                                estudo={estudo}
                                report={false}
                                popup={false}
                                simulacaoFinanceira={false}
                            />

                            <ProjecaoSucessaoVitaliciaChart
                                values={values}
                                estudo={estudo}
                                report={false}
                            />

                            <CustomizedDialogsPopupCotacao
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                vars={vars}
                                setExpandiu={setExpandiu}
                            />
                            
                            {
                                estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                .filter(item => !item.utilizarApenasComparacaoPreco)?.map( (cotacao, indCotacao) => (
                                    <div
                                        key={indCotacao}
                                    >
                                        {values.exibirResumoSeguroVidaCotacao && (
                                            <EstudoFormResumoSeguroVidaCotacao
                                                values={values}
                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                utilizarApenasComparacaoPreco={false}
                                                report={false}
                                            />
                                        )}

                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                        .filter(item => !item.utilizarApenasComparacaoPreco &&
                                        item.seguradora === cotacao.id)?.map( (item, ind) => (
                                            <div
                                                key={ind}
                                            >
                                                {!values.exibirTabelaEvolucaoCS && !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                    <EstudoFormTabelaEvolucaoValorResgate
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                                {values.exibirTabelaEvolucaoCS && (
                                                    <EstudoFormTabelaEvolucaoCS
                                                        values={values}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                                {values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                    <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                        values={values}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                                {(values.exibirTabelaEvolucaoCS ||
                                                values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                    <TabelaEvolucaoValorResgateChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                        tabelaEvolucaoValorResgate={false}
                                                    />
                                                )}
                                                {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira &&
                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                                {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira && 
                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                        values={values}
                                                        estudo={estudo}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                        report={false}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            }
                        </>
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura && (
                        <EstudoFormPatrimonialProjecaoFutura
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            handleSubmitAutomatico={handleSubmitAutomatico}
                            estudo={estudo}
                            vars={vars}
                            linhaFormList={linhaFormList}
                        />
                    )}

                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategias && (
                        <GestaoPatrimonialFormEstrategiasPlanejamento
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            jsonGestaoPatrimonial={vars.jsonGestaoPatrimonial}
                            title={LABEL.gestaoPatrimonialEstrategias}
                            idTipoGestaoPatrimonial={HARDCODE.idTipoGestaoPatrimonialEstrategia}
                        />
                    )}
                    
                    {values.tabEstudoFormList === LABEL.gestaoPatrimonialPlanejamento && (
                        <GestaoPatrimonialFormEstrategiasPlanejamento
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            jsonGestaoPatrimonial={vars.jsonGestaoPatrimonial}
                            title={LABEL.gestaoPatrimonialPlanejamento}
                            idTipoGestaoPatrimonial={HARDCODE.idTipoGestaoPatrimonialPlanejamento}
                        />
                    )}
                </DivForm>
            :
                ''
    )
}

export default EstudoForm